import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import { createModule } from 'vuex-toast'

const debug = process.env.NODE_ENV !== 'production'
import globalStore from './globalStore'
import orderStore from './orderStore'
import commentStore from './commentStore'
import adminStore from './adminStore'
import userStore from './userStore'
import dashboardStore from './dashboardStore'
import techcenterStore from './techcenterStore'

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  modules: {
    globalStore,
    orderStore,
    commentStore,
    adminStore,
    userStore,
    dashboardStore,
    techcenterStore,
    toast: createModule({
      dismissInterval: 8000
    })
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js